import { render, staticRenderFns } from "./LogoPremiumGradient.vue?vue&type=template&id=65b725c7&"
import script from "./LogoPremiumGradient.vue?vue&type=script&lang=js&"
export * from "./LogoPremiumGradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports